import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormActionService } from '../action.service';
import { SweetAlertOptions } from 'sweetalert2';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormEmailService } from '../email.service';
import { FormStatusService } from '../status.service';
import { FormDataService } from '../data.service';
import { Observable } from 'rxjs';
import { FormShareService } from '../share.service';
import { formTypes } from '../../form.constants';

@Injectable()
export class RequestSignatureFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private emailService: FormEmailService,
    private dataService: FormDataService,
    private statusService: FormStatusService,
    private swal: SwalService,
    private shareService: FormShareService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;

    // First of all, change status to 'Pending Signature'
    this.statusService.changeStatus('Pending Signature');

    return new Promise((resolve, reject) => {
      that.swal
        .show({
          title: 'This form requires a signature from Business Signatory.',
          text: 'The Business Signatory will be notified for Signature',
          type: 'info'
        })
        .then(() => {
          if (
            this.shareService.form.type === formTypes.stepApplication.abbrev
          ) {
            this.setStatusAndSendEmail(false, resolve, reject);
          }
          else {
            that.swal
              .show({
                title: 'Will the signee also pay for this form?',
                type: 'question',
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Yes',
                showCancelButton: true,
                cancelButtonText: 'No'
              })
              .then(isSigneePaying => {
                // isSigneePaying will be true, false, or null depending on what the user did clicked
                if (isSigneePaying == null) {
                  return;
                }
                this.setStatusAndSendEmail(isSigneePaying, resolve, reject);
              })
              .catch(isSigneePaying => {
                // isSigneePaying will be true, false, or null depending on what the user did clicked
                isSigneePaying = isSigneePaying === 'cancel' ? false : null;
                this.setStatusAndSendEmail(isSigneePaying, resolve, reject);
              });
          }
        })
        .catch(reason => (reason === 'cancel' ? false : null));
    });
  }

  setStatusAndSendEmail(isSigneePaying: boolean, resolve: any, reject: any) {
    const that = this;
    // Show loader
    that.swal.load('Setting form to "Pending Signature"...');
    that.dataService.saveForm().subscribe(
      saveSuccess => {
        // Save completed - update loader text and send email
        that.swal.load(
          'Sending Signature Request Email...',
          'The Business Signatory will be notified for Signature.'
        );
        that.emailService
          .sendBusinessSignatureRequiredEmail(isSigneePaying)
          .subscribe(
            emailSuccess =>
              // Email succeeded - show success swal (automatically hides loader)
              that.swal
                .success({
                  title: 'Email Sent',
                  text:
                    'An email has been sent requesting a signature for the form'
                })
                .then(resolve)
                .catch(resolve),
            emailError =>
              reject(
                "An error occurred while emailing your project's Business Signatory."
              )
          );
      },
      saveError => {
        if (saveError === 409) {
          reject(saveError);
        } else {
          reject('An error occurred while saving your form.');
        }
      }
    );
  }
}
